angular.module("EICDataStream3.pdfReportService")
  .config(function() {
  })
  .service('geographicalProjectPresenterService', ["$window", "projectDataService", "PRODUCT_URIS_CONFIG",
    function ($window, projectDataService, PRODUCT_URIS_CONFIG) {
      var geographicalProjectPresenterService = this;

      //var landingUrl = "https://geographicalprojectpresenter.the-eic.com/worldmap?projects=";
      var landingUrl = PRODUCT_URIS_CONFIG.geographicalProjectPresenter + "/worldmap?projects=";

      var getSelectedProjectIDs = function () {
        return projectDataService.projectNames
          .filter(function (item, index, ar) {
              if (item.isChecked) return true;
            }
          ).map(function (item, index, ar) {
              return item.projectID;
            }
          );
      };

      geographicalProjectPresenterService.post_selectedProjects = function() {
        //var payload = {
        //  projects: projects
        //};
        var projects = getSelectedProjectIDs();

        $window.location.href = landingUrl+projects;



        //var form = $document.createElement('form');
        //form.style.visibility = 'hidden'; // no user interaction is necessary
        //form.method = 'POST'; // forms by default use GET query strings
        //form.action = 'http://.html';

        //projects.forEach(function(projectId) {
        //  var input = $document.createElement('input');
        //  input.name = "projects";
        //  input.value = projectId;
        //  form.appendChild(input);
        //});
        ////for (key in Object.keys(payload)) {
        ////  var input = $document.createElement('input');
        ////  input.name = key;
        ////  input.value = payload[key];
        ////  form.appendChild(input); // add key/value pair to form
        ////}
        //$document.body.appendChild(form); // forms cannot be submitted outside of body
        //form.submit(); // send the payload and navigate
      };

        //pdfReportService.reportStatuses = {
        //  pending: 0,
        //  queued: 7,
        //  deferred: 1,
        //  processing: 2,
        //  ready: 3,
        //  failed: 4,
        //  tooBig: 5,
        //  stale: 6,
        //  cancelled: 8,
        //  cancelling:9
        //};


        //this.reportStatusLabel = function (status) {
        //  switch (status) {
        //  case 0:
        //    return 'Pending';
        //  case 7:
        //    return 'Queued';
        //  case 1:
        //    return 'deferred';
        //  case 2:
        //    return 'Processing';
        //  case 3:
        //    return 'Ready';
        //  case 4:
        //    return 'Failed';
        //  case 5:
        //    return 'Too Big';
        //  case 6:
        //    return 'Content Stale';
        //  case 8:
        //    return 'Cancelled by user';
        //  case 9:
        //    return 'Cancelling...';
        //  default:
        //    return 'Unknown';
        //  }
        //};


        //this.getReportsList = function (sort) {
        //  var sortQuerystring = "";
        //  if (sort) sortQuerystring = "?sortField=" + sort.sortField + "&sortDesc=" + sort.sortDesc;
        //  return $http.get("/api/PdfProjectReport/getreports" + sortQuerystring);
        //};

        //this.getReport = function(reportId) {
        //  return $http.get("/api/pdfreport/" + reportId)
        //    .then(function(response) {
        //      pdfReportService.report = response.data;

        //      pdfReportService.initialSort = {
        //        sortField: pdfReportService.report.sortOrder,
        //        sortDesc: pdfReportService.report.sortDesc
        //      };

        //      return response.data;
        //    });
        //}

        //this.gotoReport = function (report) {
        //  this.report = report;

        //  this.initialSort = {
        //    sortField: report.sortOrder || "ProjectName",
        //    sortDesc: report.sortDesc || false
        //  };

        //  $state.go("reports.pdfReport", {
        //    guid: report.reportId,
        //    name: report.title.urlEncode()
        //  });
        //};

        //this.runReport = function(reportId) {
        //  return $http.put("/api/pdfprojectreport/runreport/" + reportId,
        //    { "reportId": reportId, "requestDate": new Date() });
        //};

        //this.cancelReport = function(reportId) {
        //  return $http.put("/api/pdfprojectreport/cancel/" + reportId,
        //    {});
        //   // { "reportId": reportId, "requestDate": new Date() });
        //};

        //this.delete = function(reportId) {
        //  return $http.delete("/api/pdfprojectreport/delete/" + reportId);
        //};

        //this.deleteMany = function(reports) {
        //  var urlCalls = reports.map(function(report) {
        //    return $http.delete("/api/pdfprojectreport/delete/" + report.reportId);

        //  });


        //  var deferred = $q.defer();

        //  $q.all(urlCalls)
        //    .then(
        //      function(results) {
        //        deferred.resolve(
        //          JSON.stringify(results));
        //      },
        //      function(errors) {
        //        deferred.reject(errors);
        //      },
        //      function(updates) {
        //        deferred.update(updates);
        //      });
        //  return deferred.promise;
        //};


        //this.removeProjects = function(pdfReportParams) {
        //  var reportGuid = pdfReportParams.reportGuid;
        //  var projectIDs = pdfReportParams.projectIDs;
        //  return $http.patch("/api/pdfreport/" + reportGuid + "?operation=removeProjects", projectIDs);
        //}


        //this.restoreProject = function (reportGuid, projectId) {
        //  var projectIds = [];
        //  projectIds.push(projectId);
        //  return $http.patch("/api/pdfreport/" + reportGuid + "?operation=restoreProject", projectIds);
        //};

        //this.addProjects = function(reportGuid, projectIds) {
        //  return $http.patch("/api/pdfreport/" + reportGuid + "?operation=addProjects", projectIds);
        //}


        //this.reorderProjects = function (reportGuid, reorderProjects) {
        //  return $http.put("/api/pdfreport/reorderprojects/" + reportGuid ,reorderProjects );
        //};


        //this.updateProperties = function (reportGuid, report) {
        //  var reportProperties = {

        //    reportId:report.reportId,
        //    title: report.title,
        //    description: report.description,
        //    fileName :report.fileName
        //  }
        //  return $http.put("/api/pdfreport/updateproperties/" + reportGuid, reportProperties );

        //}

      }
    ])
  //.service('reportRequestService', [
  //  '$http', 'dialogService', 'projectDataService', 'trackingStatusService',
  //  function ($http, dialogService, projectDataService, trackingStatusService) {

  //    //////////////////////////////////////////////////////////////////////
  //    ////  Open dialog for New Report Request - Selected Projects
  //    //////////////////////////////////////////////////////////////////////

  //    this.openReportRequestDialog_selectedProjects = function () {

  //      var projectIDs = getSelectedProjectIDs();

  //      // HACK ALERT
  //      // if no projects have been explicitly chosen, then select all
  //      // those that  match the TrackingStatus selection
  //      if (projectIDs.length == 0) {
  //        projectIDs = getAllVisibleProjectIDs();
  //      }

  //      var reportParams = {
  //        title: "",
  //        description: "",
  //        fileName: "",
  //        highlightDays: 28,

  //        sort: {
  //          order: "ProjectName",
  //          direction: "ASC",
  //          pageBreak: false
  //        },
  //        criteria: "",
  //        projects: projectIDs,
  //        noteTypes: [],
  //        trackingStatuses: []

  //      };


  //      dialogService.openReportRequestDialog(reportParams);
  //    };

  //    this.openReportRequestDialog_singledProject = function (project) {

  //      var reportParams = {
  //        title: project.projectName.substring(0,50),
  //        description: project.projectName,
  //        fileName: project.projectName.substring(0,50).urlEncode() +'.pdf',
  //        highlightDays: 28,

  //        sort: {
  //          order: "ProjectName",
  //          direction: "ASC",
  //          pageBreak: false
  //        },
  //        criteria: "",
  //        projects: [project.projectID],
  //        noteTypes: [],
  //        trackingStatuses: []

  //      };
        
  //      dialogService.openReportRequestDialog(reportParams);
  //    };


  //    //////////////////////////////////////////////////////////////////////
  //    ////  Report Request Support Functions
  //    //////////////////////////////////////////////////////////////////////

  //    var getSelectedProjectIDs = function () {
  //      return projectDataService.projectNames
  //        .filter(function (item, index, ar) {
  //          if (item.isChecked) return true;
  //        }
  //        ).map(function (item, index, ar) {
  //          return item.projectID;
  //        }
  //        );
  //    };

  //    var getAllVisibleProjectIDs = function () {
  //      return projectDataService.projectNames
  //        .filter(function (item, index, ar) {
  //          if (trackingStatusService.selectedValues.indexOf(item.trackingStatusID) > -1) return true;
  //        })
  //        .map(function (item, index, ar) {
  //          return item.projectID;
  //        }
  //        );
  //    };

  //    //////////////////////////////////////////////////////////////////////
  //    this.createReport = function (reportParams) {
  //      return $http.post('/api/pdfprojectreport/create', reportParams);
  //      //    return $http.post('/api/enqueueReport', reportParams);
  //    };

  //    this.updateReport = function (reportParams) {
  //      return $http.put('/api/pdfprojectreport/update/' + reportParams.reportId, reportParams);
  //      //    return $http.post('/api/enqueueReport', reportParams);
  //    };

  //  }
  //])
